module.exports = __webpack_public_path__ + "img/poster_00.bcc7117a.jpg";